import { AUDIENCE_GENDER, AUDIENCE_GENDER_NAME } from '~/constants';
import customTheme from '~/styles/theme';

export const genderOptions = {
  [AUDIENCE_GENDER.female]: {
    value: AUDIENCE_GENDER.female,
    name: AUDIENCE_GENDER_NAME[AUDIENCE_GENDER.female],
    color: customTheme.colors.tertiary[600],
  },
  [AUDIENCE_GENDER.men]: {
    value: AUDIENCE_GENDER.men,
    name: AUDIENCE_GENDER_NAME[AUDIENCE_GENDER.men],

    color: customTheme.colors.lightBlue[700],
  },
  [AUDIENCE_GENDER.nonBinary]: {
    value: AUDIENCE_GENDER.nonBinary,
    name: AUDIENCE_GENDER_NAME[AUDIENCE_GENDER.nonBinary],
    color: customTheme.colors.beige[700],
  },
};
